import React, {useState, useEffect} from "react";
import SectionBox from "../../elements/SectionBox/SectionBox";
import TextField from "../../elements/TextField/TextField";
import Button from "../../elements/Button/Button";
import {useTranslation} from "react-i18next";
import {callAPI, log} from "../../utils/utils";
import {useSnackbar} from "notistack";
import OutlinedSelect from "../../elements/OutlinedSelect/OutlinedSelect";

const PersonalDataBox = () => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const [ email, setEmail ] = useState("");
  const [ organisation, setOrganisation ] = useState("");
  const [ firstName, setFirstName ] = useState("");
  const [ lastName, setLastName ] = useState("");
  const [ street, setStreet ] = useState("");
  const [ zipcode, setZipcode ] = useState("");
  const [ city, setCity ] = useState("");
  const [ country, setCountry ] = useState("");
  const [ working, setWorking ] = useState(true);

  useEffect(() => {
    callAPI("user").then((data) => {
      setEmail(data.personalData.email);
      setOrganisation(data.personalData.organisation);
      setFirstName(data.personalData.first_name);
      setLastName(data.personalData.last_name);
      setStreet(data.personalData.street);
      setZipcode(data.personalData.zipcode)
      setCity(data.personalData.city);
      setCountry(data.personalData.country);
      setWorking(false);
    }).catch(error => {
      log("ERROR: ", error);
    });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    setWorking(true);
    const data = {
      organisation: organisation,
      first_name: firstName,
      last_name: lastName,
      street: street,
      zipcode: zipcode,
      city: city,
      country: country
    };
    callAPI("user/update", "POST", data).then(() => {
      enqueueSnackbar(t("PersonalDataBox.SaveSuccess"), {variant:'success'});
      setWorking(false);
    }).catch(() => {
      enqueueSnackbar(t("PersonalDataBox.SaveError"), {variant:'error'});
      setWorking(false);
    });
  }

  return (
    <SectionBox headline={"PersonalDataBox.Headline"} info={"PersonalDataBox.InfoText"} width={1000} loading={working}>
      <form onSubmit={handleSubmit} style={{maxWidth:600}}>
        <div>
          <TextField
            id="email"
            label={t("PersonalDataBox.Email")}
            value={email}
            readOnly
            disabled
          />
        </div>
        <div>
          <TextField
            id="organisation"
            label={t("PersonalDataBox.Organisation")}
            value={organisation}
            onChange={(e) => setOrganisation(e.target.value)}
          />
        </div>
        <div>
          <TextField
            style={{marginRight:10,flexGrow:1}}
            id="firstName"
            label={t("PersonalDataBox.FirstName")}
            value={firstName}
            required
            onChange={(e) => setFirstName(e.target.value)}
          />
          <TextField
            id="lastName"
            label={t("PersonalDataBox.LastName")}
            value={lastName}
            required
            onChange={(e) => setLastName(e.target.value)}
          />
        </div>
        <div>
          <TextField
            id="street"
            label={t("PersonalDataBox.Street")}
            value={street}
            required
            onChange={(e) => setStreet(e.target.value)}
          />
        </div>
        <div>
          <TextField
            style={{marginRight:10,minWidth:200,width:'25%'}}
            id="postCode"
            label={t("PersonalDataBox.PostCode")}
            value={zipcode}
            required
            onChange={(e) => setZipcode(e.target.value)}
          />
          <TextField
            id="city"
            label={t("PersonalDataBox.City")}
            value={city}
            required
            onChange={(e) => setCity(e.target.value)}
          />
        </div>
        <div>
          <OutlinedSelect
            id={'country'}
            label={t("PersonalDataBox.Country")}
            value={country}
            required
            onChange={(value) => {setCountry(value);}}
            items={[{value: 'Deutschland', name: 'Deutschland'}]}
          />
        </div>
        <div>
          <Button
            type="submit"
            size="large"
            variant="contained"
            color="primary"
            working={working}
            className="submit"
          >
            {t("PersonalDataBox.Submit")}
          </Button>
        </div>

      </form>
    </SectionBox>
  );
}

export default PersonalDataBox;